import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import ValueProps from "@/components/site/ValueProps";
import BusinessTypes from "@/components/site/BusinessTypes";
import Process from "@/components/site/Process";
import SubmissionForm from "@/components/site/SubmissionForm";
import Faq from "@/components/site/Faq";
import SiteFooter from "@/components/site/SiteFooter";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-[#FDFBF7] text-[#1A2621] font-sans-body"
    >
      <Navbar />
      <Hero />
      <ValueProps />
      <BusinessTypes />
      <Process />
      <SubmissionForm />
      <Faq />
      <SiteFooter />
    </main>
  );
}
